<template lang="pug">
label
  span.label-text
    slot
  span.icon-tooltip-wrapper(v-tooltip="$t(tooltipKey)" v-if="tooltipKey")
    i.ui.icon.hint.suus-alert-circle-que
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "LabelWithHint",
  props: { tooltipKey: String },
})
</script>
